import { Habit, HabitSetup } from "@app/_interfaces/habit.interface";
import { Journal, JournalSetup } from "@app/_interfaces/journal.interface";
import { List } from "@app/_interfaces/list.interface";
import { MoneyTrackerSetup, MoneyTrackerAction } from "@app/_interfaces/money-tracker.interface";
import { Note } from "@app/_interfaces/note.interface";
import { Todo } from "@app/_interfaces/todo.interface";

export type Environment = 'dev' | 'qa' | 'staging' | 'prod' | 'hotfix';
export type Entity = List | Note | Todo | Habit | HabitSetup | Journal | JournalSetup | MoneyTrackerSetup | MoneyTrackerAction;
export type EntityName = 'focus' | 'list' | 'note' | 'todo' | 'habit' | 'journal' | 'moneyTracker' | 'calendarIntegration';

export type LanguageCode = 'en' | 'de' | 'fr' | 'es' | 'it' | 'pt' | 'ja' | 'zh' | 'ko' | 'nl' | 'sv' | 'da' | 'nb' | 'fi' | 'pl' | 'ar';
export type ThemeMode = 'dark' | 'light';
export type AppThemeType = ThemeMode | 'systemDefault';

export type AttachmentType = 'image' | 'audio' | 'video' | 'document' | 'txt';
export type EntityStatusType = 'completed' | 'hasvalue' | 'canceled' | '';
export type EntityStatus = 'all' | 'missed' | 'overdue' | 'draft' | 'skipped' | 'incomplete' | 'completed' | 'inprogress' | 'none';
export type CalendarIntegrationType = 'google' | 'microsoft';
export type SyncType = 'syncWithReminders' | 'sync' | 'disabled';
export type HabitType = 'boolean' | 'numeric' | 'timer' | 'single' | 'multiple';
export type FeatureNameType = 'focus' | 'todo' | 'note' | 'list' | 'journal' | 'moneyTracker' | CalendarIntegrationType | HabitType;
export type TimerStopType = 'onRoundEnd' | 'onGoalReached' | 'never';
export type AlarmSoundType = 'mevolve_1' | 'mevolve_2' | 'mevolve_3' | 'mevolve_4' | 'mevolve_5' | 'none';
export type AlarmFileType = 'none' | 'mevolve1' | 'mevolve2' | 'mevolve3' | 'mevolve4' | 'mevolve5';

export type ShowType = 'habitResponse' | 'setup' | 'calendarName' | 'doneDate' | 'mood' | 'date' | 'time' | 'reminder' | 'duration' | 'repeat' | 'checklist' | 'attachments' | 'label' | 'hashtag' | 'invalidEntry' | 'emptyDays' | 'description' | 'collaboratorsCount' | 'invitedUsersCount' | 'awaitingUserCount' | 'itemCount' | 'lastUpdatedAt' | 'lastUpdatedBy' | 'access' | 'categories';

export type ListItemAddOn = 'checkbox' | 'customText' | 'none';

export type ListItemGroupBy = 'none' | 'category';

export type FeatureStatus = 'active' | 'upcoming' | 'completed';

export type CalendarSyncStatus = 'synced' | 'syncing' | 'failed' | 'error' | 'notSynced';

export type EndDateRepeatMode = 'until' | 'occurrence';

export type RepeatTypeOverdue = 'Repeat' | 'Non-Repeat';

export type RepeatType = 'OFF' | 'DAILY' | 'WEEK_WORKING_DAY' | 'WEEKLY' | 'MONTHLY' | 'MONTHLY_NTH_DAY' | 'MONTHLY_LAST_DAY' | 'YEARLY';

export type DayCode = 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA' | 'SU';

export type RemindType = 'BEFORE' | 'ON_TIME' | 'AFTER';

export type CollaboraterRole = 'owner' | 'editor' | 'viewer';
export type CollaboraterStatus = 'active' | 'left' | 'blocked' | 'removed';


export type TransactionType = 'income' | 'expense';

export type RepeatFilterType = 'all' | 'one_time' | 'repeated';

export type UploadStatus = 'local' | 'cloud' | 'temporary';

export type SubscriptionEntitlement = 'free' | 'pro' | 'legend';

/** Centralized subscription tier display strings.
 *  When translation keys for Legend are added via mevolve-project,
 *  replace the hardcoded strings with translation lookups. */
export const SUBSCRIPTION_TIER_STRINGS: Record<SubscriptionEntitlement, { name: string; monthly: string; annual: string }> = {
  free: { name: 'Free', monthly: 'Free', annual: 'Free' },
  pro: { name: 'Pro', monthly: 'Pro Monthly', annual: 'Pro Annual' },
  legend: { name: 'Legend', monthly: 'Legend Monthly', annual: 'Legend Annual' },
};

export type SubscriptionStatus = 'none' | 'subscribed' | 'subscriptionExpired';

export type SubscriptionDuration = 'monthly' | 'yearly' | 'custom';

export type MuteRange = '1HOUR' | '3HOUR' | '1DAY' | '1WEEK' | 'ALWAYS' | 'CUSTOM' | 'NONE';

export type PolicyType = 'PRIVACY_POLICY' | 'TERMS_OF_USE' | 'COOKIE_POLICY' | 'END_USER_LICENSE_AGREEMENT' | 'DISCLAIMER' | 'ACCEPTABLE_USE_POLICY';

export type InAppListNotificationType = 'added' | 'update' | 'deleted' | 'private' | 'left' | 'blocked' | 'removed' | 'roleChanged' | 'inviteAccepted' | 'messageAdded' | 'published' | 'followed';
